import QueryLogsPage from "./pages/admin/queryLogs/QueryLogsPage";

export default QueryLogsPage;
